import React, { Component } from 'react'

class FileItem extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.item !== this.props.item
    }

    render() {
        return (
            <div className="file_item">
                <p className="file_item_name">{this.props.item.name || this.props.item.filename}</p>
                <div className="delete_btn" onClick={() => this.props.deleteFile(this.props.item)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
                        <g fill="none" fillRule="evenodd" stroke="#E7F4FF" strokeLinecap="round" strokeWidth="1.7">
                            <path d="M1.5 8.58L8.58 1.5M1.5 1.5l7.08 7.08" />
                        </g>
                    </svg>
                </div>
            </div>
        )
    }
}

export default FileItem



// WEBPACK FOOTER //
// ./Src/Components/Intro/FileItem.js